<script setup lang="ts">
import { Feature } from 'ol'
import Point from 'ol/geom/Point'
import Geometry from 'ol/geom/Geometry'

import { transform } from 'ol/proj'
import BaseLayerPoints from '@/components/map/base-layers/BaseLayerPoints.vue'
import { useStationDataStore } from '~/stores/stations'
import { Station } from '~/types/station'

const stationsStore = useStationDataStore()

const stations = computed(() => stationsStore.stationsWithFilters)
const features = ref<Feature<Geometry>[]>([])

onMounted(() => {
  if (stations.value.length === 0) {
    stationsStore.initStations()
    return
  }
  features.value = parseFeatures(stations.value)
})

watch(stations, () => {
  features.value = parseFeatures(stations.value)
})

function transformCoordinates(coordinates: number[]) {
  return transform(
    coordinates.map((c) => c),
    'EPSG:4326',
    'EPSG:3857'
  )
}

function parseFeatures(stations: Station[]) {
  return stations.map((station) => {
    const transformedCoords = transformCoordinates([station.lng, station.lat])
    const feature = new Feature({
      geometry: new Point(transformedCoords),
      name: station.name,
      pointType: 'station',
    })
    feature.setProperties(station)
    feature.changed()
    return feature
  })
}
</script>

<template>
  <BaseLayerPoints v-if="features.length > 0" :features="features" />
</template>
